import { useEffect, useState } from "react";

// components

import Board from "../../Components/Trello/Board.js";

export default function Projects(props) {
  const { id } = props.match.params

  const [project, setProject] = useState()

  useEffect(() => {
    fetch('https://warm-waters-06754.herokuapp.com/projects/' + id, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem("token")),
        'Content-Type': 'application/json'
      }
    }).then((response) => response.json())
      .then((data) => {
        setProject(data);
      })
      .catch((e) => {
        console.log(e.message)
      });
  }, [id]);

  return (
    <>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4 relative">
          <div className="flex flex-col min-w-0 break-words w-full mb-6 shadow-xl rounded-lg" style={{ backgroundColor: 'rgb(38,92,118)' }}>
            <div className="px-6">
              <div className="text-center mt-6 mb-6">
                <h3 className="text-4xl font-semibold leading-normal text-white mb-2">
                  {project?.projectName?.name ? project?.projectName?.name : "Project"}
                </h3>
              </div>
              <div className="w-full flex flex-wrap justify-center mb-4 relative h-screen">
                {
                  project && <Board project={project} projectId={id} />
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
